import {Controller} from "stimulus";
import xlsxPreviewUmd, { xlsxPreview } from "xlsx-preview";
import * as XLSX from "xlsx"

export default class extends Controller
{
    static targets = ["report", "title", "parameters", "loadingButton","generate", "cancelGeneration",
        "download", "downloadIcon", "downloadLoading", "downloadCancel", "preview", "viewer", "downloadDummy"
    ]

    GENERATE_ABORT_CONTROLLER = new AbortController();
    DOWNLOAD_ABORT_CONTROLLER = new AbortController();
    DISALLOWED_PARAMETERS = ["authenticity_token", "agency_name", "agency_city", "agency_type"];

    connect()
    {
        this.reportTargets.forEach(report => report.addEventListener("click", e =>
        {
            let code = report.dataset["code"];

            report.classList.add("loading");
            fetch(window.App.prefixedUrl(`/generate-report/parameters?code=${code}`))
            .then(data => 
            {
                if(!data.ok) throw new Error("Oops")
                return data.text()
            })
            .then(data =>
            {
                this.reportTargets.forEach(r => r.classList.remove("selected"));
                report.classList.add("selected");

                let name = report.dataset["name"];
                this.titleTarget.innerText = name; 
                this.titleTarget.classList.remove("hidden");

                this.generateTarget.classList.remove("hidden");

                this.parametersTarget.innerHTML = data;
                this.parametersTarget.dataset["code"] = code;
                this.parametersTarget.classList.remove("hidden");

                this.previewTarget.classList.add("hidden");
                this.downloadTarget.classList.add("hidden");
                this.downloadIconTarget.classList.add("hidden");
                App.applyFlatpickr();

                history.pushState({page: "reports"}, report.dataset["name"] + " - Generate a Report | usadealer.us", window.App.prefixedUrl("/generate-report?rp="+encodeURIComponent(report.dataset["name"])))
                document.title = report.dataset["name"] + " - Generate a Report | usadealer.us"
            })
            .catch((e) =>
            {
                let toastEvent = new CustomEvent("show-toast", { detail: "An error occurred while loading the parameters." })
                window.dispatchEvent(toastEvent);
                
            })
            .finally(() =>
            {
                report.classList.remove("loading");
            })

        }))

        this.cancelGenerationTarget.addEventListener("click", e =>
        {
            this.GENERATE_ABORT_CONTROLLER.abort();
            this.GENERATE_ABORT_CONTROLLER = new AbortController();
        })

        this.downloadTarget.addEventListener("click",e =>
        {
            this.downloadDummyTarget.click();
        })

        this.generateTarget.addEventListener("click", e =>
        {
            let form = this.parametersTarget.firstElementChild;

            if(!this.validate(form)) return;

            this.generateTarget.classList.add("hidden");

            this.loadingButtonTarget.classList.remove("hidden")
            this.cancelGenerationTarget.classList.remove("hidden");

            let data = new FormData(this.parametersTarget.firstElementChild);

            let body = {};

            body.procedure = form.dataset["method"];

            body.serverCommand = null;
            body.sqlTimeout = null;
            body.applicationCode = null;

            let parameters = {};
            data.forEach((value, key) => 
            {
                if(!this.DISALLOWED_PARAMETERS.includes(key)) parameters[key] = value
            })

            body.parameterDictionary = Object.keys(parameters).map(key =>
            {
                let value = parameters[key];
                if(key.endsWith("flag")) value = value == "0" ? "N" : "Y";

                let param = {};
                param.Name = key.split("_").map(s => this.capitalize(s)).join("");
                

                param.Value = {}
                if(value == "XLSX") value = "XLS"
                if(key == "report_code_list" && value)
                {
                    value = "<l>" + value.split(",").map(s => `<r ReportCode=\"${s.trim()}\" SelectedFlag=\"Y\"/>`).join("") + "</l>";
                }
                
                if(value == "" || value == null)
                {
                    param.Value = { IsNull: true, Value: value };
                }
                else param.Value = {Value: value};

                param.IsOutput = false;

                return param;
            })

            body.code = this.parametersTarget.dataset["code"];
            body.file_type = body.parameterDictionary.find(x => x.Name == "FileType").Value.Value;

            let name = this.parametersTarget.firstElementChild.dataset["name"];
            let downloadName = name;


            let res = fetch(window.App.prefixedUrl("/generate-report/execute"),
            {
                method: "POST",
                body: JSON.stringify(body),
                headers: { "content-type":"application/json" },
                signal: this.GENERATE_ABORT_CONTROLLER.signal
            })
            .then(res =>
            {
                if(!res.ok) throw new Error("An error occurred while generating the file.");
                return res.blob()
            })
            .then(blob =>
            {
                this.loadingButtonTarget.classList.add("hidden");
                this.cancelGenerationTarget.classList.add("hidden");
                this.viewerTarget.innerHTML = "";

                return blob;
            });
            
            let next = res;
            if(body.file_type == "PDF")
            {
                next = next.then((blob) =>
                {
                    let obj = URL.createObjectURL(blob);

                    let iframe = document.createElement("iframe");
                    iframe.src = obj;
                    iframe.style.width = "100%";
                    iframe.style.height = "100%";

                    this.viewerTarget.appendChild(iframe);

                    this.downloadDummyTarget.href = obj;
                    downloadName = name+".pdf"
                });
            }
            else if(body.file_type == "XLS")
            {
                next = next
                .then(blob =>
                {
                    let obj = URL.createObjectURL(blob);
                    this.downloadDummyTarget.href = obj;
                    downloadName = name+".xlsx"

                    return blob.arrayBuffer()
                })
                .then((buffer) =>
                {
                    let worksheet = XLSX.read(buffer, { "type":"buffer" });
                    let html = XLSX.utils.sheet_to_html(worksheet.Sheets[worksheet.SheetNames[0]]);

                    this.viewerTarget.innerHTML = html;
                })
            }
            else if(body.file_type == "CSV")
            {
                next = next.then(blob =>
                {
                    let obj = URL.createObjectURL(blob);
                    this.downloadDummyTarget.href = obj;
                    downloadName = name+".csv"

                    return blob.text()
                })
                .then((text) =>
                {
                    let div = document.createElement("div");
                    div.classList.add("csv");

                    div.innerText = text;
                    this.viewerTarget.appendChild(div);
                })
            }
            else if (body.file_type == "HTML")
            {
                next = next.then(blob =>
                {
                    let obj = URL.createObjectURL(blob);
                    this.downloadDummyTarget.href = obj;
                    downloadName = name+".html"

                    return blob.text()
                })
                .then((text) =>
                {
                    let div = document.createElement("div");
                    div.classList.add("html");

                    div.innerHTML = text;
                    this.viewerTarget.appendChild(div);
                })
            }
            
            next.then(() =>
            {
                this.downloadDummyTarget.download = downloadName;

                this.previewTarget.classList.remove("hidden");

                this.downloadTarget.classList.remove("hidden");
                this.downloadIconTarget.classList.remove("hidden");
            })
            .catch(error =>
            {
                if(error.name == "AbortError") return;
                let event = new CustomEvent("show-toast", { detail: error.message });
                window.dispatchEvent(event);
            })
            .finally(() =>
            {
                this.loadingButtonTarget.classList.add("hidden");
                this.generateTarget.classList.remove("hidden");
                this.cancelGenerationTarget.classList.add("hidden");
            })
        })
    }

    validate(form)
    {
        let pass = true;

        let requiredFields = Array.from(form.querySelectorAll(`input`)).filter(x => x.required && x.dataset.validation);

        for(let i = 0; i<requiredFields.length; i++)
        {
            let field = requiredFields[i];
            if(!field.value)
            {
                let message = field.dataset["validation"];
                let event = new CustomEvent("show-toast", { detail: "An error occurred:\n"+message });
                window.dispatchEvent(event);

                pass = false;
                break;
            }
        }

        return pass;
    }

    capitalize(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }
}